module.exports = __webpack_public_path__ + "static/media/206-gallery18.a948ec3d.jpg";